export default "__VITE_ASSET__BR6jt2X3__"